// extracted by mini-css-extract-plugin
export default {"countdown":"v0-z","srOnly":"w0-z"};